import React from 'react';
import "../Css/about.css";
import logoWhatsapp from "../Images/logo-whatsapp1.png";
import {
  AiOutlineBook,
  AiOutlineTrophy,
  AiOutlineExperiment,
  AiOutlineProject,
  AiOutlineBulb, // Agregamos AiOutlineBulb
  AiOutlineEye, // Agregamos AiOutlineEye
} from "react-icons/ai"; // Importamos todos los íconos necesarios
import Timeline from '../Components/Timeline'; // Importamos el componente de la línea del tiempo
import {
  mostrarModalInfo,
  mostrarModalOrganigrama,
} from "../Components/modales";

const KSPage = () => {
  return (
    <div className="about-container">
      {/* Primera sección: Conoce más sobre INVESTI */}
      <div className="a-panel">
        <div className="a-panel-info">
          <div className="a-imagen"></div>
          <h3>Conoce más sobre INVESTÍ</h3>
          <div className="a-info">
            {/* Botón para Título Profesional */}
            <button
              className="a-info-service"
              onClick={() =>
                mostrarModalInfo(
                  "Asesoramiento para Títulos Profesionales",
                  `<p style="text-align: justify;" class="subtitulo">Te guiamos en el proceso de obtención de tu título profesional, brindando apoyo en cada etapa del desarrollo de tu trabajo académico. Nuestro equipo de expertos te ayudará con:</p>
                  <div style="display: flex; flex-direction: column; align-items: start; gap: 10px; text-align: left;">
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Elección del tema más adecuado según tu carrera y enfoque profesional.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Investigación y desarrollo del marco teórico con fuentes actualizadas.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Análisis de datos con herramientas estadísticas especializadas.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Redacción del informe con estructura académica y normas vigentes.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Corrección y levantamiento de observaciones para una presentación exitosa.</span></div>
                  </div>`
                )
              }
            >
              <AiOutlineBook />
              <span>Título Profesional</span>
            </button>

            {/* Botón para Maestría */}
            <button
              className="a-info-service"
              onClick={() =>
                mostrarModalInfo(
                  "Asesoramiento para Maestrías",
                  `<p style="text-align: justify;" class="subtitulo">¿Estás realizando una maestría y necesitas apoyo en tu tesis o trabajo final? Te ofrecemos un servicio especializado para garantizar el éxito de tu investigación:</p>
                  <div style="display: flex; flex-direction: column; align-items: start; gap: 10px; text-align: left;">
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Definición del tema y objetivos alineados con tu línea de investigación.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Revisión y elaboración del marco teórico con fuentes académicas de alto impacto.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Aplicación de herramientas estadísticas para análisis cuantitativo y cualitativo.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Redacción académica avanzada con enfoque metodológico riguroso.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Corrección de observaciones y mejoras antes de la sustentación.</span></div>
                  </div>`
                )
              }
            >
              <AiOutlineTrophy />
              <span>Maestría</span>
            </button>

            {/* Botón para Doctorado */}
            <button
              className="a-info-service"
              onClick={() =>
                mostrarModalInfo(
                  "Asesoramiento para Doctorados",
                  `<p style="text-align: justify;" class="subtitulo">La investigación doctoral requiere un enfoque estratégico y un alto nivel de rigurosidad. Te acompañamos en todo el proceso de tu tesis doctoral con:</p>
                  <div style="display: flex; flex-direction: column; align-items: start; gap: 10px; text-align: left;">
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Selección y delimitación del tema basado en vacíos de investigación.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Búsqueda y estructuración del marco teórico con fuentes de prestigio.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Aplicación de métodos estadísticos avanzados para análisis de datos.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Redacción de artículos científicos e informes según estándares internacionales.</span></div>
                    <div style="display: flex; align-items: center; gap: 8px;"> ● <span>Corrección de observaciones y apoyo en publicaciones para revistas indexadas.</span></div>
                  </div>`
                )
              }
            >
              <AiOutlineExperiment />
              <span>Doctorado</span>
            </button>

            {/* Botón para Ver Organigrama */}
            <button
              className="a-info-service"
              onClick={() => mostrarModalOrganigrama()}
            >
              <AiOutlineProject /> {/* Ícono para el organigrama */}
              <span>Ver Organigrama</span>
            </button>
          </div>
          <h2>Descripción</h2>
          <div className="a-description">
            <p>
              INVESTÍ es una empresa dedicada a brindar un acompañamiento
              integral en la elaboración, corrección y optimización de tesis,
              monografías, artículos científicos y proyectos de investigación en
              diversas áreas del conocimiento.
            </p>
          </div>
        </div>
      </div>

      {/* Segunda sección: Misión y Visión */}
      <div className="mission-vision-section">
        <div className="mission-vision-card">
          <div className="mission-vision-icon">
            <AiOutlineBulb className="icon" /> {/* Ícono para Misión */}
          </div>
          <h3>Misión</h3>
          <p>
            Proporcionar asesoría y apoyo integral a estudiantes y profesionales
            en la elaboración de tesis y trabajos académicos, garantizando la
            calidad, originalidad y rigor científico en cada proyecto.
          </p>
        </div>

        <div className="mission-vision-card">
          <div className="mission-vision-icon">
            <AiOutlineEye className="icon" /> {/* Ícono para Visión */}
          </div>
          <h3>Visión</h3>
          <p>
            Ser la empresa líder en servicios de asesoría y elaboración de tesis
            a nivel nacional e internacional, reconocida por nuestra excelencia
            académica, innovación y compromiso con la satisfacción del cliente.
          </p>
        </div>
      </div>

      {/* Tercera sección: Nuestra Historia  */}
      <div className="a-panel-history">
        <div className="a-history-txt">
          <h1 className="history-title">Nuestra Historia</h1>
          <Timeline />  
        </div>
      </div>
      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/51961867761"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-circle whatsapp-btn-inicio"
      >
        <img
          src={logoWhatsapp}
          alt="WhatsApp"
          className="whatsapp-icon-inicio"
        />
      </a>
    </div>
  );
};

export default KSPage;
